import React from 'react';

import OAuthLogin from '../../components/loginpages/OAuthLogin';
import { LoginComponentProps } from '../../types/LoginFormData';
import { TSPCategory, TSPConfig, createOAuthHelpText } from '../types';
import { OAuthHandlers } from '../types';

const samsaraConfig: TSPConfig = {
  key: 'samsara',
  name: 'Samsara',
  category: TSPCategory.OAUTH,

  // OAuth configuration
  oauth: {
    authUrl: 'https://api.samsara.com/oauth2/authorize',
    requiredParams: ['client_id', 'response_type', 'redirect_uri', 'state'],
    getRedirectUri: (linkState: string) =>
      `${process.env.REACT_APP_REDIRECT_URL}/samsara`,
    // Note: redirect_uri IS required and must match exactly what's configured in Samsara OAuth app settings
    // State parameter is passed separately, not in the redirect URI
    // API field mappings for the onboard endpoint (uses default 'api_key' field)
    callbackOptions: {
      // Samsara doesn't need any custom field mappings - uses all defaults
    },
  },

  helpText: createOAuthHelpText('Samsara'),
  loginComponent: (
    props: LoginComponentProps,
    oAuthHandlers?: OAuthHandlers
  ) => {
    return (
      <OAuthLogin
        onDirectConnect={() => {
          oAuthHandlers?.initiateOAuth('samsara');
        }}
        tsp='samsara'
        serviceName={props.serviceName || ''}
        onValidityChange={props.onValidityChange}
      />
    );
  },
};

export default samsaraConfig;
